/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Determines how the form designer handles multiple simultaneous users.
 */
export enum FormConcurrencyMode {
    FIRST_IN_WINS = 'FirstInWins',
    READ_ONLY_WHEN_SHARED = 'ReadOnlyWhenShared',
    ALLOW_CONCURRENT = 'AllowConcurrent',
    REQUEST_CONTROL = 'RequestControl',
}
